import { ACTION } from "@common/constants/redux";

export const setNotiConfigFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_NOTI_CONFIG_FILTER,
      payload: filter,
    });
  };
};
